(function (Drupal, $) {
  Drupal.behaviors.productCarousel = {
    attach: function (context, settings) {
      if (window.innerWidth < 768) return;

      $('.field--name-field-product-carousel-item', context).once('productCarousel').each(function () {

        var $carousel = $(this);
        var $controls = $carousel.find('.slider-control');
        var $content = $carousel.find('.slider-content');

        // Initialize Slick for the content slider
        $content.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: $controls
        });

        // Initialize Slick for the control slider (titles)
        $controls.slick({
          slidesToShow: $controls.find('.slider-control-item').length,
          slidesToScroll: 1,
          asNavFor: $content,
          focusOnSelect: true,
          arrows: false,
          centerMode: false
        });

        // Optional: make keyboard focus work
        $controls.find('.slider-control-item').on('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            var index = $(this).index();
            $content.slick('slickGoTo', index);
          }
        });
      });
    }
  };

  Drupal.behaviors.singleOpenAccordion = {
    attach: function (context) {

      const accordions = context.querySelectorAll('.mobile-only section');
      accordions.forEach((accordion) => {
        // Get all <details> elements inside this accordion
        const items = accordion.querySelectorAll('details.accordion-item');
        items.forEach((item) => {
          // Add event listener to each <details>
          item.addEventListener('toggle', function () {
            // Only react when this item is opening
            if (item.open) {
              // Close all other <details> elements
              items.forEach((other) => {
                if (other !== item) {
                  other.removeAttribute('open');
                }
              });
            }
          });
        });
      });
    }
  };
})(Drupal, jQuery);
